import { smoothScroll } from './smoothScroll';
import { newsSlider, contentSlider } from './slider';
import { worldmapScript } from './worldmap';

jQuery(() => {
  smoothScroll();
  newsSlider();
  contentSlider();
  worldmapScript();
  // ... any other imports and calls
});
